import * as DTSdk from '@dynatrace/oneagent-sdk';

import { passTraceIdToErrorStream } from '@/infra/logs/dynatrace/link-with-kibana.mjs';

let instance: DTSdk.OneAgentSDK;
import { isServerSide } from '@/helpers/isServerSide';

const createDTInstance = () => {
  const DTInstance = DTSdk.createInstance();

  if (DTInstance.getCurrentState() !== (0 as DTSdk.SDKState.ACTIVE)) {
    console.error('Dynatrace: SDK is not active!');
  }

  DTInstance.setLoggingCallbacks({
    error: (msg) => console.error('Dynatrace SDK error: ' + msg),
    warning: (msg) => console.error('Dynatrace SDK warning: ' + msg),
  });

  return DTInstance;
};

export const getDTInstance = () => {
  if (!instance) {
    instance = createDTInstance();
    return instance;
  }

  return instance;
};

export const getDTTraceId = () => {
  const instance = getDTInstance();
  const startTime = Date.now();
  let isConnectedToOneAgent = false;

  while (isServerSide() && Date.now() - startTime < 2000) {
    if (instance.getCurrentState() === (0 as DTSdk.SDKState.ACTIVE)) {
      isConnectedToOneAgent = true;
      break;
    }
  }

  if (!isConnectedToOneAgent) {
    console.error("Dynatrace: couldn't connect to OneAgent");
  }

  const traceContextInfo = instance.getTraceContextInfo();

  console.log('DT instance state', instance.getCurrentState());
  console.log('DT instance traceContextInfo', JSON.stringify(traceContextInfo || {}));
  if (!traceContextInfo.isValid) {
    return '';
  }

  const traceId = traceContextInfo.traceid;
  passTraceIdToErrorStream(traceId);

  return traceId;
};
